import React from "react"

export const IconCheckboxChecked = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" fill="none" viewBox="0 0 20 19">
      <path
        fill="#84BC26"
        d="M4.426 1.956a2.779 2.779 0 00-2.451 2.418 44.043 44.043 0 000 10.232c.148 1.266 1.172 2.275 2.451 2.418a45.83 45.83 0 0010.097 0c1.28-.143 2.303-1.152 2.451-2.418.286-2.442.367-4.903.242-7.355a.224.224 0 01.065-.17l1.161-1.161a.222.222 0 01.378.139 45.71 45.71 0 01-.18 8.742c-.24 2.054-1.889 3.662-3.93 3.89a47.51 47.51 0 01-10.47 0C2.198 18.463.55 16.855.31 14.8a45.72 45.72 0 010-10.622C.55 2.126 2.198.517 4.24.289a47.508 47.508 0 0110.47 0c.719.08 1.389.332 1.966.714a.214.214 0 01.029.331l-.898.898a.236.236 0 01-.279.036 2.78 2.78 0 00-1.005-.312 45.83 45.83 0 00-10.097 0z"
      ></path>
      <path
        fill="#84BC26"
        d="M19.569 2.817a.838.838 0 10-1.186-1.185l-9.467 9.467-2.76-2.76A.838.838 0 004.97 9.523l3.353 3.353a.838.838 0 001.186 0l5.03-5.03 5.03-5.03z"
      ></path>
    </svg>
  )
}
